import { createReducer, on } from "@ngrx/store";
import { produce } from "immer";
import { SecurityState } from "../../models/state/app-state";
import { SecurityStateAction } from "./security-state.actions";

export const initialState: SecurityState = {
  systemPermissions: null,
  installationPermissionsIsLoading: undefined,
  installationPermissions: null,
  installationPermissionsError: null,
}

export const securityStateReducere = createReducer(
  initialState,

  // Installation Permissions
  on(SecurityStateAction.getInstallationPermissions, (state) => ({
    ...state, installationPermissionsIsLoading: true, systemPermissions: null, installationPermissions: null
  })),
  on(SecurityStateAction.getInstallationPermissionsSuccess, (state, action) => ({
    ...state,
    systemPermissions: action.systemPermissions,
    installationPermissions: action.installationPermissions,
    installationPermissionsIsLoading: false,
  })),
  on(SecurityStateAction.getInstallationPermissionsFailed, (state, action) => ({
    ...state, installationPermissionsIsLoading: false,
    error: action.error
  })),

  // System Permissions (loaded independently of installation context; only touches systemPermissions
  // so it never clobbers already-loaded installationPermissions). Shares the loading flag + failure
  // action with the installation load, which the admin panel guard waits on.
  on(SecurityStateAction.getSystemPermissions, (state) => ({
    ...state, installationPermissionsIsLoading: true, systemPermissions: null
  })),
  on(SecurityStateAction.getSystemPermissionsSuccess, (state, action) => ({
    ...state, installationPermissionsIsLoading: false, systemPermissions: action.systemPermissions
  })),
)